module.exports = __webpack_public_path__ + "img/babybook-baby.c053a73c.svg";